import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { copyTextToClipboard } from '../../utils/clipboard';

/**
 * PlainQueryDisplay - Simple query display with plain pre tag styling and copy button
 * Matches the refined query style with light background and monospace font
 */
export const PlainQueryDisplay = ({ sql, title }) => {
    const { t } = useTranslation('ui-common');
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await copyTextToClipboard(sql);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <div className="w-full">
            <div className="relative bg-gray-50 border border-gray-200 rounded-lg p-4 overflow-x-auto">
                {/* Copy Button */}
                <button
                    onClick={handleCopy}
                    className="absolute right-3 top-3 z-10 p-1.5 text-gray-500 hover:text-gray-700 bg-white border border-gray-200 rounded-md transition-all hover:bg-gray-50"
                    title={t('copyToClipboard')}
                >
                    {copied ? (
                        <Check className="w-4 h-4" />
                    ) : (
                        <Copy className="w-4 h-4" />
                    )}
                </button>

                {/* Query Title (optional) */}
                {title && (
                    <p className="text-xs font-medium text-gray-500 mb-2">{title}</p>
                )}

                {/* Code Block */}
                <pre className="text-xs font-mono text-gray-800 whitespace-pre-wrap break-words">
                    {sql}
                </pre>
            </div>
        </div>
    );
};
